import { render, staticRenderFns } from "./Abonos.vue?vue&type=template&id=871b8a02"
import script from "./Abonos.vue?vue&type=script&lang=js"
export * from "./Abonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports